import routerOptions0 from "/home/jetmix/production/storebusters-landing/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions0,
}